import { Injectable } from '@angular/core';
import { IPrizesParams } from '@fantaz/shared/data-access/models';
import { select, Store, Action } from '@ngrx/store';

import * as PrizesActions from './prizes.actions';
import * as PrizesFeature from './prizes.reducer';
import * as PrizesSelectors from './prizes.selectors';

@Injectable()
export class PrizesFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(PrizesSelectors.getPrizesLoaded));
  loading$ = this.store.pipe(select(PrizesSelectors.getPrizesLoading));
  allPrizes$ = this.store.pipe(select(PrizesSelectors.getAllPrizes));
  prizesWon$ = this.store.pipe(select(PrizesSelectors.getPrizesWon));
  selectedPrizes$ = this.store.pipe(select(PrizesSelectors.getSelected));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(params: IPrizesParams) {
    this.store.dispatch(PrizesActions.init({ params }));
  }
}
